const Hero = ({ text, backdrop }) => {
	return (
		<div className='container'>
			<header className='	text-white p-5 hero-container'>
				<h1 className='hero-text'>{text}</h1>
				{backdrop && (
					<div
						className='hero-backdrop'
						style={{ backgroundImage: `url(${backdrop})` }}
					></div>
				)}
			</header>
		</div>
	);
};

export default Hero;
